import React from "react";
import reactDOM from "react-dom/client";
import "./index.css";

const manicureData = [
    {
        id: 1,
        name: "Snake",
        imgSrc: "manicure_photos/1.jpg",
    },
    {
        id: 2,
        name: "Red Snake",
        imgSrc: "manicure_photos/2.jpg",
    },
    {
        id: 3,
        name: "White Peach",
        imgSrc: "manicure_photos/3.jpg",
    },
    {
        id: 4,
        name: "White Green Snake",
        imgSrc: "manicure_photos/4.jpg",
    },
];


function App() {
    return (
        <div className="container">
            <Header/>
            <Service/>
            <Footer/>
        </div>
    );
}


function Header() {
    return (
        <header>
            <h1 className="header">Welcome to OK Beauty Salon</h1>
        </header>
    );
}

function Footer() {
    return <footer className="footer">We're open!</footer>
}

function Service() {
    return (
        <main className="service">
            <h2>Our manicure photos:</h2>
            <ul className='manicure-list'>
                {manicureData.map((manicure) =>
                    <ManicurePhoto manicureObj={manicure} key={manicure.id}/>)}
            </ul>
        </main>
    )
}

function ManicurePhoto(props) {
    return (
        <li className="manicure">
            <img src={props.manicureObj.imgSrc} alt={props.manicureObj.name}/>
            <h3>{props.manicureObj.name}</h3>
        </li>
    );
}

reactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode><App/></React.StrictMode>
);